import React, { Component } from "react";
import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import _ from "lodash";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import Multiselect from "react-widgets/lib/Multiselect";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

// Css
import "../../assets/css/groupmanagement.css";

// Image
import userIcon from "../../assets/img/groupmanagement/users_icon.png";
import lockIcon from "../../assets/img/groupmanagement/locks_icon.png";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    viewDetailsBtn: "View Details",
    groupProfileHeader: "Lock Group Profile",
    membersTitle: "Members",
    locksTitle: "Lock Group Locks",
    groupNameLabel: "Lock Group Name :",
    groupDescriptionLabel: "Lock Group Description :",
    groupMembersLabel: "Group Member List",
    nameHeader: "Name",
    emailHeader: "Email",
    noDataTitle: "There is no data to display",
  },
  ja: {
    viewDetailsBtn: "詳細",
    groupProfileHeader: "グループ名",
    membersTitle: "メンバー",
    locksTitle: "スマートロック",
    groupNameLabel: "グループ名",
    groupDescriptionLabel: "グループメモ",
    groupMembersLabel: "グループメンバーリスト",
    nameHeader: "名前",
    emailHeader: "Eメール",
    noDataTitle: "表示するデータがありません。",
  },
  es: {
    viewDetailsBtn: "Ver Detalles",
    groupProfileHeader: "Perfil del Grupo de Candados",
    membersTitle: "Miembros",
    locksTitle: "Candados del Grupo de Candados",
    groupNameLabel: "Nombre del Grupo de Candados:",
    groupDescriptionLabel: "Descripción del Grupo de Candados:",
    groupMembersLabel: "Lista de Miembros del Grupo",
    nameHeader: "Nombre",
    emailHeader: "Correo Electrónico",
    noDataTitle: "No hay datos para mostrar",
  },
});

export class LockGroupProfile extends Component {
  constructor(props) {
    super(props);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;

    var lockgrouparray = [];
    _.map(row.locks, (lockData) => {
      lockgrouparray.push(lockData);
    });

    this.state = {
      _notificationSystem: null,
      cell: cell,
      row: row,
      showPopup: false,
      lockGroupID: row.lockGroupID,
      name: row.name,
      desc: row.desc,
      groupLocksArrayList: lockgrouparray,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
    };

    this.handleGroupProfilePopupOpen = this.handleGroupProfilePopupOpen.bind(
      this
    );
    this.handleGroupProfilePopupClose = this.handleGroupProfilePopupClose.bind(
      this
    );
  }

  // componentWillReceiveProps(nextProps) {
  //   var lockgrouparray = [];
  //   _.map(nextProps.rowValue.groupLocks, lockData => {
  //       lockgrouparray.push(lockData);
  //   });

  //   this.setState({
  //     cell: nextProps.cellValue,
  //     row: nextProps.rowValue,
  //     lockGroupID: nextProps.rowValue.lockGroupID,
  //     name: nextProps.rowValue.name,
  //     desc: nextProps.rowValue.desc,
  //     groupLocksArrayList: lockgrouparray
  //   });
  // }

  componentDidUpdate(prevProps) {
    if (prevProps.rowValue !== this.props.rowValue) {
      const newLockGroupArray = [];
      _.map(this.props.rowValue.locks, (lockData) => {
        newLockGroupArray.push(lockData);
      });

      this.setState({
        cell: this.props.cellValue,
        row: this.props.rowValue,
        lockGroupID: this.props.rowValue.lockGroupID,
        name: this.props.rowValue.name,
        desc: this.props.rowValue.desc,
        groupLocksArrayList: newLockGroupArray,
      });
    }
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();
            const memberDetails = superAdminData.members;
            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;
              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;

      returnArr.push(item);
    });
    return returnArr;
  };

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  handleGroupProfilePopupOpen() {
    this.setState({
      showPopup: true,
    });
  }

  handleGroupProfilePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <span
          onClick={this.handleGroupProfilePopupOpen}
          style={{ fontSize: "1.5em" }}
          data-notify="icon"
          className="fas fa-info-circle"
          id="detailsIcon"
        ></span>
        {/* </Button> */}
        {/* //! Popup for Group Profile */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleGroupProfilePopupClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.groupProfileHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
            <div
              className="groupSummary"
              style={{
                textAlign: "center",
                display: "flex",
              }}
            >
              <div style={{ width: "100%" }}>
                <img
                  src={lockIcon}
                  alt="lock_image"
                  width="70px"
                  height="70px"
                />
                <h1 style={{ marginTop: "15px" }}>
                  {this.state.groupLocksArrayList.length}
                </h1>
                <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                  {localizationStrings.locksTitle}
                </h5>
              </div>
            </div>
            <hr />
            <div
              className="groupDetailsContainer"
              style={{ display: "flex", padding: "20px 40px" }}
            >
              <div
                className="groupDetailsLabel"
                style={{ width: "50%", paddingRight: "30px" }}
              >
                <p>{localizationStrings.groupNameLabel}</p>
                <br />
                <p>{localizationStrings.groupDescriptionLabel}</p>
              </div>
              <div className="groupDetailsText" style={{ width: "50%" }}>
                <p>{this.state.name}</p>
                <br />
                <p>{this.state.desc !== "" ? this.state.desc : "-"}</p>
              </div>
            </div>
            <hr />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default LockGroupProfile;
